export const GPU= [
    {"name":"Select your choice","Score":0},
    { "name": "NVIDIA GeForce RTX 3070", "Score": 1 },
    { "name": "NVIDIA GeForce RTX 2080 Ti", "Score": 2 },
    { "name": "NVIDIA Titan RTX", "Score": 3 },
    { "name": "AMD Radeon RX 6800", "Score": 4 },
    { "name": "NVIDIA GeForce RTX 3080", "Score": 5 }, 
    { "name": "NVIDIA Quadro RTX A6000", "Score": 6 }, 
    { "name": "AMD Radeon RX 6800 XT", "Score": 7 },
    { "name": "AMD Radeon 6900 XT", "Score": 8 },
    { "name": "NVIDIA GeForce RTX 3080 Ti", "Score": 9 },
    {"name": "NVIDIA GeForce RTX 3090","Score": 10}

]